export const ExerciseStatus = {
  pending: 'pending',
  completed: 'completed',
  skipped: 'skipped',
  replaced: 'replaced',
} as const;

export type ExerciseStatus = (typeof ExerciseStatus)[keyof typeof ExerciseStatus];

export const WorkoutSessionStatus = {
  pending: 'pending',
  inProgress: 'in_progress',
  completed: 'completed',
  reduced: 'reduced',
} as const;

export type WorkoutSessionStatus = (typeof WorkoutSessionStatus)[keyof typeof WorkoutSessionStatus];

export const Equipment = {
  treadmill: 'treadmill',
  bike: 'bike',
  bench: 'bench',
  dumbbells: 'dumbbells',
  none: 'none',
} as const;

export type Equipment = (typeof Equipment)[keyof typeof Equipment];
